const toggleLocale = () => {
    return {
        type: 'TOGGLE_LOCALE'
    }
}

export {
    toggleLocale
}


/** WEBPACK FOOTER **
 ** ./src/redux/actions.js
 **/